import { render, staticRenderFns } from "./config_task.vue?vue&type=template&id=5f2bde91&scoped=true&"
import script from "./config_task.vue?vue&type=script&lang=js&"
export * from "./config_task.vue?vue&type=script&lang=js&"
import style0 from "./config_task.vue?vue&type=style&index=0&id=5f2bde91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bde91",
  null
  
)

export default component.exports